// extracted by mini-css-extract-plugin
export default {"container":"TopAnime_container__wlgqp","left":"TopAnime_left__+Cu6c","right":"TopAnime_right__QUMfh"};